export const OVERVIEW_VISIBILITY_FIELDS = [
  'taskClassification',
  'projectMembers',
  'clientId',
  'status',
  'initialEstimatedHrs',
  'totalHrs',
  'startDate',
  'endDate',
  'actualStartDate',
  'actualEndDate',
  'projectUATDate',
  'projectLiveDate',
  'health',
  'risk',
  'allowOverSpent',
  'allowManualTask',
];

export const DEFAULT_OVERVIEW_VISIBILITY = OVERVIEW_VISIBILITY_FIELDS.reduce((acc, field) => {
  acc[field] = true;
  return acc;
}, {});
